import { isFlightForceBundled } from 'lib/offer/isFlightForceBundled'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import React, { useCallback, useRef } from 'react'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import OfferCapacityWithAgesSelection from 'components/OfferPage/Filters/CapacityWithAges/OfferCapacityWithAgesSelection'
import ModalContent from 'components/Luxkit/Modal/ModalContent'

interface Props {
  capacities: Array<App.RoomCapacity>;
  offer: App.Offer;
}
function FlashMobileStickyHeaderFiltersCapacityModal(props: Props) {
  const { capacities, offer } = props
  const modalElement = useModalElementContext<string>()
  const formRef = useRef<HTMLFormElement>(null)
  const onClose = useCallback(() => {
    if (formRef.current?.reportValidity()) {
      modalElement.resolve('')
    }
  }, [modalElement])

  return (<ModalBase mode="drawer">
    <form onSubmit={onClose} ref={formRef}>
      <ModalHeader title="Who is going?" onCloseButtonClick={onClose} />
      <ModalBody>
        <ModalContent flush>
          <OfferCapacityWithAgesSelection
            capacities={capacities}
            disableMultiRoom={isFlightForceBundled(offer)}
          />
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Confirm',
          onClick: onClose,
        }}
      />
    </form>
  </ModalBase>)
}

export default FlashMobileStickyHeaderFiltersCapacityModal
